import { render } from "./SiteTitle.vue?vue&type=template&id=0fd0586f&scoped=true"
import script from "./SiteTitle.vue?vue&type=script&lang=ts"
export * from "./SiteTitle.vue?vue&type=script&lang=ts"

import "./SiteTitle.vue?vue&type=style&index=0&id=0fd0586f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0fd0586f"

export default script